import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1200px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    margin: 0;
    color: #000;
  }

  h3 {
    text-align: left;
    margin: 10px 0 5px 0;
    color: #333;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  /* Novo Estilo de Listagem */
  .confirms-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 0 5px;
    margin-top: 20px;
  }

  .confirm-card {
    background: #fff;
    padding: 15px 20px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: grid;
    grid-template-columns: 2fr 1.5fr 1.5fr;
    gap: 15px;
    align-items: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    width: 100%;

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(3px);
    }

    @media (max-width: 800px) {
      grid-template-columns: 1fr 1fr;
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      flex-direction: column;
      strong {
        font-size: 14px;
        color: #333;
      }
      span {
        font-size: 11px;
        color: #008037;
        font-weight: bold;
      }
    }

    .info-item {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      color: #666;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        margin-bottom: 2px;
      }
      span {
        font-weight: 500;
      }
    }

    .status-badge {
      padding: 4px 12px;
      border-radius: 50px;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      text-align: center;
      width: fit-content;

      &.confirmado { background: #f6ffed; color: #52c41a; border: 1px solid #b7eb8f; }
      &.pendente { background: #fffbe6; color: #faad14; border: 1px solid #ffe58f; }
    }
  }
`;
